module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAgMAAADyVVYGAAAACVBMVEUAK3/////OESbXH0AUAAAAKklEQVR4AWMY3GAUhOIAIYNcZlRmFQ6wgnyZUZlRmVGZQV4ejMoMUTAKADrINZI9B4RqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Costa Rica.png
// module id = 565
// module chunks = 0